module.exports = __webpack_public_path__ + "static/18-0bc30674662189c454b30579432f5df7.png";